import { IFileUpload } from "../../components/FileUpload/FileUpload.type";
import { LoadState } from "../../constants/enums";

export interface ICommonState {
  policies: {
    list: IPolicies[];
    loadState: LoadState;
  };
  generalHistory: {
    list: IGeneralHistory[];
    loading: LoadState;
  };

  activityComment: {
    list: IActivityComment[];
    loading: LoadState;
  };
  recordCounts: {
    list: IRecordCount[];
    loading: LoadState;
  };
  auditLogs: {
    list: IAuditLog[];
    loading: LoadState;
  };
  engineerProgress: {
    data: IEngineerProgress[];
    loading: LoadState;
  };
}

export interface IPolicies {
  type: string;
  subTypes: {
    policy_id: number;
    name: string;
  }[];
}

export interface IGeneralHistory {
  insert_ts: string;
  [key: string]: any;
}

export interface IRecordCount {
  status: string;
  count: number;
}

export const defaultCommonState: ICommonState = {
  policies: {
    list: [],
    loadState: LoadState.NotLoaded,
  },
  generalHistory: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  activityComment: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  recordCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  auditLogs: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  engineerProgress: {
    data: [],
    loading: LoadState.NotLoaded,
  },
};

export interface IMail {
  emails: string[];
  subject: string;
  body: string;
  templateName: string | null;
  objectVariables: any;
  cc: string[];
  bcc: string[];
  reply_to?: {
    email: string;
    name: string;
  };
  attachments?: {
    content: string;
    filename: string;
  }[];
}

export interface IQueryParams {
  status?: string;
  page: number;
  rowsPerPage: number;
  columns?: string[];
  value?: string;
  fromDate?: string;
  toDate?: string;
  billing_company_uuid?: string;
  product_uuid?: string;
}

export interface IActivityComment {
  comment_t_uuid: string;
  record_uuid: string;
  table_name: string;
  attachment: IFileUpload[];
  comment_remark: string;
  status: string;
  created_by_name: string;
  created_by_uuid: string;
  modified_by_uuid: string;
  create_ts: string;
  insert_ts: string;
}

export interface IAuditLog {
  audit_log_uuid: string;
  task_uuid: string;
  action: string;
  field_name?: string;
  old_value?: string;
  new_value?: string;
  created_by_name: string;
  created_by_uuid: string;
  insert_ts: string;
  remark?: string;
  message?: string;
  changes?: any;
}

export type IActiveStatus = "ACTIVE" | "INACTIVE";

export interface IEngineerProgress {
  hold: number;
  in_progress: number;
  completed: number;
  pending: number;
  total: number;
}

export const defaultEngineerProgress: IEngineerProgress = {
  hold: 0,
  in_progress: 0,
  completed: 0,
  pending: 0,
  total: 0,
};

export interface IDataTableV2SearchFilterSearchItem {
  column: string[];
  operator: string;
  value: string;
  logicalOperator: "AND" | "OR";
}

export type IDatatableV2AdvancedSearchFilter =
  IDataTableV2SearchFilterSearchItem[];
